/**
 * UI-only store for the cart drawer's open state. Sits next to the cart
 * items store so anywhere in the tree can open/close the drawer without
 * prop-drilling through AppLayout.
 *
 * The drawer itself lives in AppLayout (`components/app-shell/CartDrawer.tsx`)
 * — there's only one. Marketplace's old per-screen drawer is gone; its
 * triggers now flip this flag instead.
 */

import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export const cartUi = {
  open() {
    if (open) return;
    open = true;
    emit();
  },
  close() {
    if (!open) return;
    open = false;
    emit();
  },
  toggle() {
    open = !open;
    emit();
  },
};

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useCartOpen(): boolean {
  return useSyncExternalStore(subscribe, () => open);
}
